import * as React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import BarChartIcon from "@mui/icons-material/BarChart";
import LayersIcon from "@mui/icons-material/Layers";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ReceiptIcon from "@mui/icons-material/Receipt";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import {useAppDispatch, useAppSelector } from "../../Hooks/reduxHook";
import { selectIsAdmin } from "../../Features/slice/userSlice";
import { Colors } from "Utils/colors";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { getAccessToken } from "Features/slice/customer/customer.Slice"; 

const defaultSideMenuState = {
  invoice: false,
  customer: false,
};

export const MainListItems = ({
  onClick,
}: {
  onClick: (event: string) => void;
}) => {
  const isAdmin = useAppSelector(selectIsAdmin);

  const dispatch = useAppDispatch();
  const { access_token } = useAppSelector((state: any) => state.customer);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [sideMenuState, setSideMenuState] = useState(defaultSideMenuState);
  const [activeItem, setActiveItem] = useState<string | null>(null);
  
  useEffect(() => {
    dispatch(getAccessToken());
  }, [dispatch]);

  useEffect(() => {
    if (pathname === "/invoice/createInvoice") {
      setSideMenuState({
        ...defaultSideMenuState,
        invoice: true,
      });
      setActiveItem("/invoice/createInvoice");
    } else if (pathname === "/customers/createCustomer") {
      setSideMenuState({
        ...defaultSideMenuState,
        customer: true,
      });
      setActiveItem("/customers/createCustomer");
    }
  }, [pathname]);

  const handleClick = (field: "invoice" | "customer" | "", state: boolean, path: string) => {
    const stateChange = field !== "" ? { [field]: state } : {};
    setSideMenuState({
      ...defaultSideMenuState,
      ...stateChange,
    });
    setActiveItem(path); 
  };

  const isActive = (path: string) => {
    return activeItem === path;
  };
  

  const handleCardClick = async (type: string) => {
     
    await dispatch(getAccessToken());
    
      navigate("/invoice/invoiceDetails", { state: { type } });
      setActiveItem(`/invoice/invoiceDetails/${type}`);
    
  };

  const handleDraftClick = async () => {
     
    await dispatch(getAccessToken());
    
      navigate("/invoice/draftList");
      setActiveItem(`/invoice/draftList`);
    
  };

  return (
    <React.Fragment>


      {/* <ListItemButton
        onClick={() => {
          handleClick("", false, "dashboard");
          onClick("dashboard");
        }}
        className="left-sec-menu-all"
        sx={{
          borderRight: isActive("dashboard") ? "2px solid #fff" : "0",
          mr: isActive("dashboard") ? "20px" : 0,
        }}
      >
        <ListItemIcon sx={{ color: Colors.white }}>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItemButton> */}


      <>
        <ListItemButton
          onClick={() => {
            handleClick("invoice", !sideMenuState.invoice, "/invoice/createInvoice");
            if (!sideMenuState.invoice) {
              onClick("/invoice/createInvoice");
            }
          }}
          className="left-sec-menu-all"
          sx={{
            borderRight: isActive("/invoice/createInvoice") ? "2px solid #fff" : "0",
            mr: isActive("/invoice/createInvoice") ? "20px" : 0,
          }}
        >
          <ListItemIcon sx={{ color: Colors.white }}>
            <ReceiptIcon />
          </ListItemIcon>
          <ListItemText primary="Invoices" />
        </ListItemButton>

        <Collapse in={sideMenuState.invoice} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton
              sx={{
                pl: 8,
                borderRight: isActive("/invoice/createInvoice") ? "2px solid #fff" : "0",
                mr: isActive("/invoice/createInvoice") ? "10px" : 0,
              }}
              onClick={() => {
                onClick("/invoice/createInvoice");
                setActiveItem("/invoice/createInvoice");
              }}
            >
              <ListItemText primary="Create Invoice" />
            </ListItemButton>

            <ListItemButton
              sx={{
                pl: 8,
                borderRight: isActive("/invoice/draftList") ? "2px solid #fff" : "0",
                mr: isActive("/invoice/draftList") ? "10px" : 0,
              }}
              onClick={handleDraftClick}
            >
              <ListItemText primary="Saved Drafts" />
            </ListItemButton>

            <ListItemButton
              sx={{
                pl: 8,
                borderRight: isActive("/invoice/invoiceDetails/recentlyCompleted") ? "2px solid #fff" : "0",
                mr: isActive("/invoice/invoiceDetails/recentlyCompleted") ? "10px" : 0,
              }}
              onClick={() => handleCardClick("recentlyCompleted")}
            >
              <ListItemText primary="Recently Completed" />
            </ListItemButton>

            <ListItemButton
              sx={{
                pl: 8,
                borderRight: isActive("/invoice/invoiceDetails/pendingPayment") ? "2px solid #fff" : "0",
                mr: isActive("/invoice/invoiceDetails/pendingPayment") ? "10px" : 0,
              }}
              onClick={() => handleCardClick("pendingPayment")}
            >
              <ListItemText primary="Pending Payment" />
            </ListItemButton>
          </List>
        </Collapse>
      </>
      <>
        <ListItemButton
          onClick={() => {
            handleClick("customer", !sideMenuState.customer, "/customers/createCustomer");
            if (!sideMenuState.customer) {
              onClick("/customers/createCustomer");
            }
          }}
          className="left-sec-menu-all"
          sx={{
            borderRight: isActive("/customers/createCustomer") ? "2px solid #fff" : "0",
            mr: isActive("/customers/createCustomer") ? "20px" : 0,
          }}
        >
          <ListItemIcon sx={{ color: Colors.white }}>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary="Customers" />
        </ListItemButton>

        <Collapse in={sideMenuState.customer} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton
              sx={{
                pl: 10,
                borderRight: isActive("/customers/createCustomer") ? "2px solid #fff" : "0",
                mr: isActive("/customers/createCustomer") ? "10px" : 0,
              }}
              onClick={() => {
                onClick("/customers/createCustomer");
                setActiveItem("/customers/createCustomer");
              }}
            >
              <ListItemText primary="Add New Customer" />
            </ListItemButton>
          </List>
        </Collapse>
      </>
      <ListItemButton
        onClick={() => {
          handleClick("", false, "shipping");
          onClick("shipping");
        }}
        className="left-sec-menu-all"
        sx={{
          borderRight: isActive("shipping") ? "2px solid #fff" : "0",
          mr: isActive("shipping") ? "20px" : 0,
        }}
      >
        <ListItemIcon sx={{ color: Colors.white }}>
          <BarChartIcon />
        </ListItemIcon>
        <ListItemText primary="Shipping" />
      </ListItemButton>
      <ListItemButton
        onClick={() => {
          handleClick("", false, "inventory");
          onClick("../inventory");
        }}
        className="left-sec-menu-all"
        sx={{
          borderRight: isActive("inventory") ? "2px solid #fff" : "0",
          mr: isActive("inventory") ? "20px" : 0,
        }}
      >
        <ListItemIcon sx={{ color: Colors.white }}>
          <LayersIcon />
        </ListItemIcon>
        <ListItemText primary="Inventory" />
      </ListItemButton>
      {isAdmin && (
        <ListItemButton
          onClick={() => {
            handleClick("", false, "users");
            onClick("../users");
          }}
          className="left-sec-menu-all"
          sx={{
            borderRight: isActive("users") ? "2px solid #fff" : "0",
            mr: isActive("users") ? "20px" : 0,
          }}
        >
          <ListItemIcon sx={{ color: Colors.white }}>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary="Users" />
        </ListItemButton>
      )}
    </React.Fragment>
  );
};

export const SecondaryListItems = (
  <React.Fragment>
    <ListSubheader component="div" inset>
      Saved reports
    </ListSubheader>
    <ListItemButton>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Current month" />
    </ListItemButton>
    <ListItemButton>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Last quarter" />
    </ListItemButton>
    <ListItemButton>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Year-end sale" />
    </ListItemButton>
  </React.Fragment>
);


